<template>
  <div class="newsList dataTable" :style="commonCtlSty"
       v-show="showCtlFlag"
       :class="sectionConfig.mode!=='alternate'&&sectionConfig.mode!=='right'&&sectionConfig.isOneLine===true?'data-one-line':'timelineItem'">
    <Skeleton active v-if="state.loadingFlag"/>
    <template v-else="!state.loadingFlag">
      <div class="newsListBody"  :bordered="false">
        <template v-for="(record,index) in tableDs">
          <div @click="openRecordDetail(record)" class="new-record-item">
            <div class="list-header">{{record.title}}</div>
            <div class="content-div-collapse" v-html="record.announcementContent"></div>
            <div class="detail-btn">
              <a-tag @click="openRecordDetail(record)" color="cyan">详情</a-tag>
            </div>
          </div>
        </template>

      </div>
      <div v-if="tableDs&&tableDs.length===0">
        <a-empty/>
      </div>
    </template>

    <!-- 抽屉组件 -->
    <a-drawer
      title="消息详情"
      :width="720"
      class="newsListDrawer"
      :visible="drawerVisible"
      @close="handleDrawerClose"
    >
      <div class="title-bold">标题:{{ selectedRecord?.title }}</div>
      <div v-html="decodeHTMLEntities(selectedRecord?.announcementContent)"></div>
    </a-drawer>

  </div>
</template>


<script lang="ts">
import {defineComponent} from 'vue';
import componentsCtls from "@/gateway-main/contentTemp/recordContent";
import i18n from "@/i18n";

export default defineComponent({
  components: {
    ...componentsCtls,
  },
  label: i18n.global.t('时间轴'),
  name: 'newsList',
});
</script>

<script lang="ts" setup>
import {Skeleton, Collapse as ACollapse,Empty as  AEmpty,Drawer as ADrawer, CollapsePanel as ACollapsePanel,Tag as ATag} from 'ant-design-vue';
import {computed, toRefs, onMounted, nextTick, watch} from "vue";
import {useI18n} from "vue-i18n";
import {useCtlShowState} from "@/main-page/ctls/hooks/useCtlShowState";
import {useDataDealHooks} from "./hooks/useDataDealHooks";
import {useCtlSty} from "@/gateway-main-base/hooks/useCtlSty";

const {t} = useI18n();

interface propTypes {
  borderConfig: any,
  ctlItem: any,
  sectionConfig: any,
  showFlag: boolean,
  styles: any,
  dataConfig: any,
  pId: string,
  events: any,
  drawerVisibleComputed: boolean,
  selectedRecordComputed: any,
}

const props = withDefaults(defineProps<propTypes>(), {
  borderConfig: {},
  sectionConfig: {},
  ctlItem: {},
  events: [],
  styles: {},
  pId: '',
  dataConfig: {},
  showFlag: true,
  drawerVisibleComputed: false,
  selectedRecordComputed: {},
});
const {borderConfig, dataConfig, sectionConfig, showFlag, events, styles}: any = toRefs(props);


const {showCtlFlag} = useCtlShowState({sectionConfig});
//如果显示列集合为空 则初始化一个
if (unref(dataConfig)["showCols"] == null) {
  unref(dataConfig)["showCols"] = {
    titleCol: {},
    dateCol: {}
  };
}
//数据处理hook
const {state, initCtlDataFun, showCols, tableDs} = useDataDealHooks({dataConfig, borderConfig, showFlag})
const {
  commonCtlSty
} = useCtlSty(borderConfig, sectionConfig, props.pId);

const emit = defineEmits(["afterLoading","update:drawerVisibleComputed",'update:selectedRecordComputed']);
emit('afterLoading', {flag: true});
onMounted(() => {
  initCtlDataFun();
})
const activeKey = ref('');
watch(tableDs,(newVal)=>{
  if(unref(tableDs)[0]){
    activeKey.value=unref(tableDs)[0]['id'];
  }
})
watch(
  () => props.drawerVisibleComputed,
  (newVal) => {
    console.log(newVal,"子组件修改了");
    drawerVisible.value = newVal;
  }
);
watch(
  () => props.selectedRecordComputed,
  (newVal) => {
    console.log(newVal,"子组件修改了");
    selectedRecord.value = newVal;
  }
);
const selectedRecord = ref(null);
const drawerVisible = ref(false);
const decodeHTMLEntities = (text: string): string => {
  // const parser = new DOMParser();
  // const dom = parser.parseFromString(text, 'text/html');
  // return dom.body.textContent || '';
  const content = selectedRecord.value?.announcementContent || '';
  return content
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");
};
const handleDrawerClose = () => {
  drawerVisible.value = false;
  emit('update:drawerVisibleComputed', false);
  emit('update:selectedRecordComputed', {});
};
const openRecordDetail = (record: any) => {
  selectedRecord.value = record;
  drawerVisible.value = true;
  // emit('update:selectedRecordComputed', record);
  // emit('update:drawerVisibleComputed', true);
};

const showMsgDrawer=function (record){
  openRecordDetail(record)
}
defineExpose({showMsgDrawer})
</script>

<style type="text/css" lang="less">
.newsList {
  padding: 16px;
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 6px 16px;
    background-color: #FFF;
  }
  .list-header{
    &:hover{
      color:var(--primary-color,#0a6cd5);
    }
  }

  .ant-collapse-borderless > .ant-collapse-item {
    border-bottom: 1px solid #eee;
  }

  .new-record-item{
    position: relative;
    margin-bottom: 16px;

    .content-div-collapse{
      font-size:13px;
    }
  }

  .content-div-collapse {
    color: #888;
    width: 100%;
    padding-left:8px;
    padding-top:4px;

    line-height: 26px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
  }
  .ant-collapse-content{
    position: relative;
  }
  .detail-btn {
    position: absolute;
    right: 20px;
    top: 3px;
  }

}

.newsListDrawer .title-bold {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
}
</style>
